import { render, staticRenderFns } from "./complaintList.vue?vue&type=template&id=14aac762&scoped=true"
import script from "./complaintList.vue?vue&type=script&lang=js"
export * from "./complaintList.vue?vue&type=script&lang=js"
import style0 from "./complaintList.vue?vue&type=style&index=0&id=14aac762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14aac762",
  null
  
)

export default component.exports